import api from '@pray/shared/utils/api';

export async function updatePushCampaign({
  artistId = undefined,
  campaignId = undefined,
  name = undefined,
  status = undefined,
  scheduledAt = undefined,
  title = undefined,
  body = undefined,
  imageUrl = undefined,
  deeplink = undefined,
  presentation = undefined,
  badgeCount = undefined,
  audiences = undefined,
}) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!campaignId) throw new Error('Campaign ID is required');

  const data = {
    name,
    status,
    scheduled_at: scheduledAt,
    title,
    body,
    image_url: imageUrl,
    deeplink,
    presentation,
    badge_count: badgeCount,
    audiences,
  };

  const url = `/web/studio/artists/${artistId}/campaigns/push/${campaignId}`;
  const response = await api.executePutRequest(url, data);

  return response.data;
}
